"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const OpenInFull_1 = __importDefault(require("@mui/icons-material/OpenInFull"));
const CloseFullscreen_1 = __importDefault(require("@mui/icons-material/CloseFullscreen"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const better_react_mathjax_1 = require("better-react-mathjax");
const shared_1 = require("../shared");
const styles_1 = require("@mui/styles");
const react_resizable_1 = require("react-resizable");
function PaperComponent(props) {
    return ((0, jsx_runtime_1.jsx)(react_draggable_1.default, Object.assign({ handle: '#draggable-dialog-title', cancel: '[class*="MuiDialogContent-root"]' }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({}, props)) })));
}
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    resizable: {
        position: 'relative',
        '& .react-resizable-handle': {
            position: 'absolute',
            width: 20,
            height: 20,
            bottom: 0,
            right: 0,
            background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
            'background-position': 'bottom right',
            padding: '0 3px 3px 0',
            'background-repeat': 'no-repeat',
            'background-origin': 'content-box',
            'box-sizing': 'border-box',
            cursor: 'se-resize',
        },
    },
}));
function RefDialog({ description, onClose }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isFullscreen, setIsFullscreen] = React.useState(false);
    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };
    const [contentApi, setContentApi] = React.useState(null);
    const closeDialog = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };
    React.useEffect(() => {
        GetCmsUrl();
    }, []);
    const GetCmsUrl = async () => {
        setContentApi(await (0, shared_1.getCmsURL)());
    };
    const handleClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            closeDialog();
        }
    };
    const imageStyles = {
        height: isFullscreen ? '62vh' : '100%',
        width: isFullscreen ? '55vw' : '100%',
        display: 'block',
        marginTop: '1rem', // Add space between text and image
    };
    const renderImage = (data) => {
        const imageRegex = /!\[([^\]]*?)\]\(([^)]*?)\)/g;
        const newData = data === null || data === void 0 ? void 0 : data.replace(imageRegex, (match, altText, imageUrl) => {
            // Wrap the image in a div to force it onto a new line
            return `<div class="image-container">
					<img style='height: ${imageStyles.height}; width: ${imageStyles.width}; 
					max-width: 100%; max-height: 100%; object-fit: contain; display: block;' 
					alt='${altText}' src='${contentApi}${imageUrl}' />
				  </div>`;
        });
        return newData;
    };
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, hideBackdrop: true, disableEnforceFocus: true, disableEscapeKeyDown: true, maxWidth: 'lg', style: { pointerEvents: 'none' }, PaperProps: { style: { pointerEvents: 'auto' } }, onClose: handleClose, PaperComponent: PaperComponent, "aria-labelledby": 'draggable-dialog-title' }, { children: (0, jsx_runtime_1.jsx)(react_resizable_1.ResizableBox, Object.assign({ height: isFullscreen ? window.innerHeight - 170 : 640, width: isFullscreen ? window.innerWidth - 950 : 600, minConstraints: [400, 300], maxConstraints: [1000, 800], className: classes.resizable }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', height: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)(DialogTitle_1.default, Object.assign({ style: { cursor: 'move', height: 45 }, id: 'draggable-dialog-title' }, { children: ["Reference Sheet", (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'FullScreen', onClick: toggleFullscreen, sx: {
                                    position: 'absolute',
                                    right: 50,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                } }, { children: isFullscreen ? (0, jsx_runtime_1.jsx)(CloseFullscreen_1.default, {}) : (0, jsx_runtime_1.jsx)(OpenInFull_1.default, {}) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'close', onClick: () => closeDialog(), sx: {
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, Object.assign({ sx: {
                            flex: '1 1 auto',
                            margin: '1rem 2rem',
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                        } }, { children: (0, jsx_runtime_1.jsx)(better_react_mathjax_1.MathJax, Object.assign({ inline: true, dynamic: true }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'content-wrapper' }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: renderImage(description) } }) })) })) })), (0, jsx_runtime_1.jsx)(DialogActions_1.default, Object.assign({ sx: { height: '60px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: closeDialog }, { children: "Close" })) }))] })) })) })));
}
exports.default = RefDialog;
